var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"no-border e-invoice mobile-barcode",attrs:{"type":"text","pattern":"^\\/[0-9A-Z.+-]{7}$","placeholder":"+新增","maxlength":8},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }